// extracted by mini-css-extract-plugin
export default {"container":"pageNotFoundStyle_container__KNiAp","img":"pageNotFoundStyle_img__xloNf","label":"pageNotFoundStyle_label__xYbsF"};